module.exports = __webpack_public_path__ + "fonts/3ccf189.ttf";